<template>
  <div class="home-container">
    <!-- 1. 背景：金色立柱舞台（全场贯穿） -->
    <div class="stage-bg-decor">
      <div class="pillar p1"></div><div class="pillar p2"></div>
      <div class="pillar p3"></div><div class="pillar p4"></div>
    </div>

    <div class="scroll-content">
      <!-- 2. 顶部 Banner 区域 -->
      <div class="top-banner-wrap">
        <swiper :options="bannerSwiperOption" class="banner-swiper">
          <swiper-slide v-for="(v, k) in banners" :key="k">
            <div class="banner-img-container">
              <van-image :src="v.url" fit="cover" class="b-img" />
            </div>
          </swiper-slide>
        </swiper>
      </div>

      <!-- 3. 中部核心 3D 轮动推荐 -->
      <div class="middle-3d-stage">
        <swiper class="movie_swiper_3d" :options="movielistSwiperOption">
          <swiper-slide v-for="(v, key) in movielist_0" :key="key">
            <div class="card-3d-inner" @click="toPlayVideo(v.id)">
              <van-image :src="v.cover" fit="cover" class="c-img" />
            </div>
          </swiper-slide>
        </swiper>
      </div>

      <!-- 4. 底部标题 -->
      <div class="section-title">당신에게 추천하는</div>

      <!-- 5. 底部两列视频列表 (还原图片最下方部分) -->
      <div class="bottom-video-grid">
        <div class="video-item" v-for="(v, key) in movielist_1" :key="key" @click="toPlayVideo(v.id)">
          <van-image :src="v.cover" fit="cover" class="v-img" />
        </div>
      </div>
      
      <!-- 占位防止被遮挡 -->
      <div style="height: 100px;"></div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      banners: [],
      movielist_0: [{}, {}, {}, {}, {}], // 3D轮播数据
      movielist_1: [{}, {}, {}, {}],      // 底部列表数据
      bannerSwiperOption: {
        loop: true,
        autoplay: { delay: 3000 }
      },
      // ⭐ 核心 3D 配置：精准匹配截图效果
      movielistSwiperOption: {
        effect: 'coverflow',
        centeredSlides: true,
        slidesPerView: 'auto',
        loop: true,
        speed: 600,
        coverflowEffect: {
          rotate: 0,        // [重要] 保持正面对准用户，不旋转
          stretch: -70,     // [重要] 负值越大，两边的图重叠在中间图后面的部分越多
          depth: 150,       // [重要] 深度，控制侧边图缩小程度
          modifier: 1,      
          slideShadows: false
        }
      }
    };
  },
  methods: {
    toPlayVideo(id) {
      this.$router.push(localStorage.getItem('token') ? `/PlayVideo?id=${id}` : '/Login');
    },
    getBasicConfig() {
      this.$http({ method: 'get', url: 'sys_config' }).then(res => {
        const data = res.data;
        this.banners = data.banners || [];
        this.movielist_0 = data.movielist_0 || [];
        this.movielist_1 = data.movielist_1 || [];
      });
    }
  },
  created() {
    this.getBasicConfig();
  }
};
</script>

<style lang='less' scoped>
.home-container {
  position: fixed;
  inset: 0;
  background-color: #000;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}


.scroll-content {
  position: relative;
  z-index: 10;
  padding-top: 30px;
}

/* Banner 样式：矩形圆角 */
.top-banner-wrap {
  width: 100;
  margin: 0 auto 40px;
  .banner-img-container {
    height: 350px;
    border-radius: 30px;
    overflow: hidden;
    box-shadow: 0 10px 30px rgba(0,0,0,0.5);
    .b-img { width: 100%; height: 100%; }
  }
}

/* 核心 3D 轮播区域 */
.middle-3d-stage {
  padding: 40px 0;
  perspective: 100px;
  
  .movie_swiper_3d {
    overflow: visible !important;
    
    .swiper-slide {
      width: 400px; // 中间主图宽度
      height: 300px; // 中间主图高度
      transition: all 0.5s ease;
    }

    .card-3d-inner {
      width: 100%; height: 100%;
      border-radius: 25px;
      overflow: hidden;
      background: #1a1a1a;
      box-shadow: 0 30px 60px rgba(0, 0, 0, 0.9);
      .c-img { width: 100%; height: 100%; }
    }

    /* 激活态：中间大图显示亮色和金边 */
    .swiper-slide-active {
      z-index: 100 !important;
      .card-3d-inner {
        border: 3px solid #e2c07d;
        box-shadow: 0 0 40px rgba(226, 192, 125, 0.4);
        filter: brightness(1.1);
      }
    }

    /* 非激活态：侧边变小变暗并退后 */
    .swiper-slide:not(.swiper-slide-active) {
      opacity: 0.6;
      filter: brightness(0.35) grayscale(0.4);
      z-index: 1 !important;
    }
  }
}

/* 标题样式 */
.section-title {
  margin: 60px 0 30px 50px;
  color: #ffeb3b;
  font-size: 42px;
  font-weight: bold;
}

/* 底部视频列表（还原截图下半部） */
.bottom-video-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
  padding: 0 40px;
  
  .video-item {
    height: 300px;
    border-radius: 15px;
    overflow: hidden;
    background: #111;
    .v-img { width: 100%; height: 100%; }
  }
}

/* 兼容 Vant 图片圆角 */
/deep/ .van-image__img {
  border-radius: inherit;
}
</style>